import { useAuthStore } from '@/stores/auth'
import { useMessagingStore } from '@/stores/messaging'

export function useMessagingUnread(): number {
  const uid = useAuthStore((s) => s.user?.uid)
  const conversations = useMessagingStore((s) => s.conversations)
  if (!uid) return 0
  return conversations.filter((c) => {
    if (c.archivedFor?.includes(uid)) return false
    if (c.lastSenderUid === uid) return false
    if (!c.lastMessageAt) return false
    const readAt = c.lastReadAt?.[uid]
    if (!readAt) return true
    return readAt.toMillis() < c.lastMessageAt.toMillis()
  }).length
}
